import { useEffect, useState } from 'react';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';

export default function Entretien() {
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Entretien Chaudière & Climatisation Valence | Maintenance Obligatoire | Ion Certan';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Entretien chaudière et climatisation obligatoire à Valence. Ion Certan assure la maintenance annuelle de vos équipements avec attestation officielle. Contrat entretien, tarif préférentiel dépannage. Valence, Bourg-lès-Valence, Guilherand-Granges.');
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://plombier-chauffagiste-sanitaire.fr/services/entretien');
    }
    return () => {
      if (metaDesc) {
        metaDesc.setAttribute('content', 'Plombier Chauffagiste et Sanitaire à Valence. Ion Certan, artisan expert en installation climatisation, chauffage, plomberie et rénovation salle de bains. Intervention rapide à Valence, Bourg-lès-Valence, Guilherand-Granges. Devis gratuit. Noté 5,0 sur Google.');
      }
      if (canonical) {
        canonical.setAttribute('href', 'https://plombier-chauffagiste-sanitaire.fr/');
      }
    };
  }, []);

  const services = [
    {
      icon: 'ri-fire-line',
      title: 'Entretien Chaudière Gaz',
      description: 'Entretien annuel obligatoire de votre chaudière gaz à Valence. Nettoyage complet, réglages, contrôle des émissions, vérification sécurité. Attestation d\'entretien remise conformément à la réglementation.',
      obligatoire: true,
      image: 'https://public.readdy.ai/ai/img_res/d0c3fe7db8536198367c4bf4f9ff6669.jpg',
      points: [
        'Nettoyage corps de chauffe et brûleur',
        'Contrôle combustion CO/CO2',
        'Vérification sécurité et évacuation',
        'Attestation officielle remise'
      ]
    },
    {
      icon: 'ri-temp-cold-line',
      title: 'Entretien Climatisation',
      description: 'Entretien obligatoire tous les 2 ans pour les climatiseurs de plus de 4 kW. Nettoyage filtres, désinfection unités, contrôle étanchéité circuit frigorifique, vérification performances énergétiques.',
      obligatoire: true,
      image: 'https://readdy.ai/api/search-image?query=hvac%20technician%20cleaning%20air%20conditioning%20unit%20filters%20maintenance%20service%20indoor%20unit%20wall%20mounted%20simple%20clean%20background%20realistic%20detailed%20professional%20photography%20high%20quality%20bright%20lighting&width=600&height=400&seq=entretien-climatisation-valence-2025&orientation=landscape',
      points: [
        'Nettoyage filtres et unités intérieures',
        'Contrôle étanchéité fluide frigorigène',
        'Désinfection antibactérienne',
        'Vérification performances énergétiques'
      ]
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Contrat Entretien Annuel',
      description: 'Formule tout compris pour l\'entretien de tous vos équipements à Valence. Interventions programmées, tarif préférentiel dépannage, priorité intervention urgente. Sérénité garantie toute l\'année.',
      obligatoire: false,
      image: 'https://readdy.ai/api/search-image?query=professional%20service%20contract%20document%20clipboard%20checklist%20maintenance%20schedule%20calendar%20planning%20simple%20clean%20background%20realistic%20detailed%20professional%20photography%20high%20quality%20bright%20lighting%20business&width=600&height=400&seq=contrat-entretien-valence-2025&orientation=landscape',
      points: [
        'Entretiens programmés automatiquement',
        'Tarif préférentiel -15% sur dépannages',
        'Intervention prioritaire sous 24h',
        'Extension possible tous équipements'
      ]
    }
  ];

  const avantages = [
    {
      icon: 'ri-shield-check-line',
      title: 'Conformité réglementaire',
      description: 'Respect des obligations légales d\'entretien avec attestation officielle'
    },
    {
      icon: 'ri-money-euro-circle-line',
      title: 'Économies d\'énergie',
      description: 'Réduction significative de votre facture énergétique annuelle'
    },
    {
      icon: 'ri-time-line',
      title: 'Durée de vie prolongée',
      description: 'Augmente la longévité de vos équipements de manière significative'
    },
    {
      icon: 'ri-alert-line',
      title: 'Prévention des pannes',
      description: 'Détection précoce des problèmes avant qu\'ils ne deviennent graves'
    }
  ];

  const checklist = [
    'Nettoyage complet du corps de chauffe et du brûleur',
    'Contrôle et réglage de la combustion (CO, CO2)',
    'Vérification du système d\'évacuation des fumées',
    'Contrôle de la pression et du vase d\'expansion',
    'Test des organes de sécurité et de régulation',
    'Vérification de l\'étanchéité du circuit gaz',
    'Nettoyage ou remplacement des filtres',
    'Contrôle du circulateur et de la pompe',
    'Mesure du rendement énergétique',
    'Remise de l\'attestation d\'entretien obligatoire'
  ];

  const processus = [
    {
      numero: '01',
      titre: 'Prise de rendez-vous',
      description: 'Contactez-moi pour planifier l\'entretien à la date qui vous convient'
    },
    {
      numero: '02',
      titre: 'Intervention complète',
      description: 'Réalisation des 10 points de contrôle obligatoires selon la réglementation'
    },
    {
      numero: '03',
      titre: 'Rapport détaillé',
      description: 'Explication des opérations effectuées et conseils personnalisés'
    },
    {
      numero: '04',
      titre: 'Attestation officielle',
      description: 'Remise de l\'attestation d\'entretien à conserver pour votre assurance'
    }
  ];

  const marques = [
    { nom: 'Saunier Duval', note: 5 },
    { nom: 'Viessmann', note: 5 },
    { nom: 'Daikin', note: 5 },
    { nom: 'Atlantic', note: 5 },
    { nom: 'Vaillant', note: 5 },
    { nom: 'De Dietrich', note: 5 }
  ];

  const temoignages = [
    {
      nom: 'Martine D.',
      ville: 'Valence',
      note: 5,
      texte: 'Entretien de chaudière très professionnel. Ion a pris le temps de tout m\'expliquer et m\'a remis l\'attestation immédiatement. Je recommande vivement pour l\'entretien annuel obligatoire à Valence.'
    },
    {
      nom: 'Olivier H.',
      ville: 'Bourg-lès-Valence',
      note: 5,
      texte: 'J\'ai souscrit un contrat d\'entretien annuel pour ma chaudière et ma climatisation. Service impeccable, intervention programmée automatiquement. Très pratique et tarifs préférentiels sur les dépannages.'
    },
    {
      nom: 'Sandrine T.',
      ville: 'Guilherand-Granges',
      note: 5,
      texte: 'Entretien climatisation réalisé dans les règles. Nettoyage complet des filtres, désinfection, contrôle du fluide. Ma clim fonctionne beaucoup mieux maintenant. Merci pour ce service de qualité !'
    }
  ];

  const faq = [
    {
      question: 'L\'entretien de la chaudière est-il obligatoire à Valence ?',
      answer: 'Oui, l\'entretien annuel de la chaudière gaz est obligatoire en France depuis 2009, que vous soyez propriétaire ou locataire à Valence. Cette obligation concerne toutes les chaudières de 4 à 400 kW. L\'entretien doit être réalisé par un professionnel qualifié qui vous remettra une attestation d\'entretien à conserver et à présenter à votre assurance en cas de sinistre.'
    },
    {
      question: 'Quelle est la fréquence d\'entretien pour une climatisation à Valence ?',
      answer: 'Pour les climatiseurs de puissance supérieure à 4 kW (soit la majorité des installations résidentielles), l\'entretien est obligatoire tous les 2 ans minimum selon le décret n°2020-912. Pour les systèmes de plus de 70 kW, un contrôle annuel est requis. Même si votre climatisation est de puissance inférieure, je recommande un entretien annuel pour maintenir les performances optimales et garantir une bonne qualité d\'air intérieur à Valence.'
    },
    {
      question: 'Quel est le prix d\'un entretien de chaudière à Valence ?',
      answer: 'Le tarif d\'un entretien de chaudière gaz à Valence dépend du type de chaudière et de son accessibilité. Je propose également des contrats d\'entretien annuels à tarif préférentiel qui incluent l\'entretien obligatoire plus des avantages (dépannage prioritaire, tarif réduit sur les réparations). Contactez-moi pour un devis personnalisé gratuit.'
    },
    {
      question: 'Quand faut-il faire entretenir sa chaudière dans l\'année ?',
      answer: 'L\'idéal est de faire entretenir votre chaudière avant la période de chauffe, soit en septembre ou octobre à Valence. Cela permet de détecter d\'éventuels problèmes avant l\'hiver et d\'éviter une panne de chauffage en plein froid. Toutefois, l\'entretien peut être réalisé toute l\'année. L\'entretien doit être effectué au maximum tous les 12 mois.'
    },
    {
      question: 'Que comprend un contrat d\'entretien annuel à Valence ?',
      answer: 'Mon contrat d\'entretien annuel à Valence comprend : l\'entretien obligatoire de votre chaudière avec attestation, un contrôle préventif de votre installation de chauffage, un dépannage prioritaire en cas de panne, un tarif préférentiel sur toutes les réparations et pièces détachées, et la possibilité d\'étendre le contrat à vos autres équipements (climatisation, chauffe-eau).'
    },
    {
      question: 'L\'entretien permet-il vraiment de faire des économies d\'énergie ?',
      answer: 'Oui, absolument ! Une chaudière bien entretenue consomme nettement moins d\'énergie qu\'une chaudière mal entretenue. Le nettoyage du corps de chauffe et le réglage optimal de la combustion améliorent significativement le rendement énergétique. L\'entretien est donc rapidement rentabilisé, sans compter qu\'il évite les pannes coûteuses et prolonge la durée de vie de votre chaudière.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section with Background Image */}
      <section className="relative pt-20 sm:pt-32 pb-12 sm:pb-20 min-h-[500px] sm:min-h-screen flex items-center">
        <div className="absolute inset-0 z-0">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20heating%20boiler%20maintenance%20service%20professional%20technician%20inspection%20tools%20equipment%20clean%20organized%20workshop%20background%20realistic%20detailed%20professional%20photography%20high%20quality%20bright%20lighting%20teal%20orange%20accents&width=1920&height=1080&seq=entretien-hero-background-valence-2025&orientation=landscape"
            alt="Entretien chaudière et climatisation à Valence"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-teal-900/85 via-teal-800/80 to-orange-900/75"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="max-w-3xl">
            <div className="inline-block px-3 sm:px-4 py-1.5 sm:py-2 bg-teal-500/90 backdrop-blur-sm rounded-full mb-4 sm:mb-6">
              <span className="text-xs sm:text-sm font-semibold text-white">Entretien Obligatoire</span>
            </div>
            <h1 className="text-2xl sm:text-4xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight">
              Entretien Chaudière et Climatisation à Valence
            </h1>
            <p className="text-base sm:text-lg lg:text-xl text-teal-50 mb-6 sm:mb-8 leading-relaxed">
              Plombier chauffagiste à Valence, j'assure l'entretien obligatoire de votre chaudière, climatisation et tous vos équipements thermiques. Maintenance préventive pour éviter les pannes et optimiser vos consommations.
            </p>
            
            <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4 mb-8 sm:mb-12">
              <a
                href="tel:+33760705475"
                className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 bg-white text-teal-600 font-semibold rounded-lg hover:bg-teal-50 transition-colors shadow-xl whitespace-nowrap cursor-pointer text-sm sm:text-base"
              >
                <i className="ri-phone-line mr-2"></i>
                07 60 70 54 75
              </a>
              <a
                href="mailto:ioncertanpro@gmail.com"
                className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 bg-teal-600/90 backdrop-blur-sm border-2 border-white text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors shadow-xl whitespace-nowrap cursor-pointer text-sm sm:text-base"
              >
                <i className="ri-mail-line mr-2"></i>
                Demander un devis
              </a>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
              <div className="flex items-center bg-white/10 backdrop-blur-sm px-3 sm:px-4 py-2 sm:py-3 rounded-lg border border-white/20">
                <i className="ri-file-text-line text-xl sm:text-2xl text-white mr-2 sm:mr-3"></i>
                <span className="text-xs sm:text-sm font-semibold text-white">Attestation officielle</span>
              </div>
              <div className="flex items-center bg-white/10 backdrop-blur-sm px-3 sm:px-4 py-2 sm:py-3 rounded-lg border border-white/20">
                <i className="ri-calendar-check-line text-xl sm:text-2xl text-white mr-2 sm:mr-3"></i>
                <span className="text-xs sm:text-sm font-semibold text-white">Contrat annuel</span>
              </div>
              <div className="flex items-center bg-white/10 backdrop-blur-sm px-3 sm:px-4 py-2 sm:py-3 rounded-lg border border-white/20">
                <i className="ri-shield-check-line text-xl sm:text-2xl text-white mr-2 sm:mr-3"></i>
                <span className="text-xs sm:text-sm font-semibold text-white">Garantie conformité</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="py-3 sm:py-4 bg-gray-50 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center text-xs sm:text-sm text-gray-600">
            <a href="/" className="hover:text-teal-600 transition-colors cursor-pointer">Accueil</a>
            <i className="ri-arrow-right-s-line mx-1 sm:mx-2"></i>
            <span className="text-gray-900 font-semibold">Entretien</span>
          </div>
        </div>
      </section>

      {/* Services Entretien avec Images */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Nos Prestations d'Entretien à Valence
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
              Maintenance préventive de tous vos équipements de chauffage et climatisation
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-8">
            {services.map((service, index) => (
              <div key={index} className="bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-2xl transition-shadow group">
                <div className="relative h-40 sm:h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                  {service.obligatoire && (
                    <span className="absolute top-3 sm:top-4 right-3 sm:right-4 px-2 sm:px-3 py-0.5 sm:py-1 bg-orange-500 text-white text-xs font-semibold rounded-full whitespace-nowrap shadow-lg">
                      Obligatoire
                    </span>
                  )}
                  {!service.obligatoire && (
                    <span className="absolute top-3 sm:top-4 right-3 sm:right-4 px-2 sm:px-3 py-0.5 sm:py-1 bg-teal-500 text-white text-xs font-semibold rounded-full whitespace-nowrap shadow-lg">
                      Recommandé
                    </span>
                  )}
                </div>
                <div className="p-4 sm:p-6">
                  <div className="flex items-start justify-between mb-3 sm:mb-4">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-gradient-to-br from-teal-600 to-teal-700 rounded-lg flex-shrink-0">
                      <i className={`${service.icon} text-xl sm:text-2xl text-white`}></i>
                    </div>
                  </div>
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">{service.title}</h3>
                  <p className="text-xs sm:text-sm text-gray-600 leading-relaxed mb-3 sm:mb-4">{service.description}</p>
                  <ul className="space-y-1.5 sm:space-y-2">
                    {service.points.map((point, idx) => (
                      <li key={idx} className="flex items-start text-xs sm:text-sm text-gray-700">
                        <i className="ri-check-line text-teal-600 mr-2 mt-0.5 flex-shrink-0"></i>
                        <span>{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Avantages */}
      <section className="py-12 sm:py-20 bg-gradient-to-br from-teal-50 via-white to-orange-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Les Avantages d'un Entretien Régulier
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
              Pourquoi faire entretenir vos équipements par un professionnel à Valence ?
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-8">
            {avantages.map((avantage, index) => (
              <div key={index} className="text-center bg-white p-6 sm:p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all hover:-translate-y-1 group">
                <div className="w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center bg-gradient-to-br from-teal-600 to-orange-600 rounded-xl mx-auto mb-3 sm:mb-4 group-hover:scale-110 transition-transform">
                  <i className={`${avantage.icon} text-2xl sm:text-3xl text-white`}></i>
                </div>
                <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2">{avantage.title}</h3>
                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">{avantage.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Checklist Entretien */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
            <div>
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">
                10 Points de Contrôle Obligatoires
              </h2>
              <p className="text-base sm:text-lg text-gray-600 mb-6 sm:mb-8 leading-relaxed">
                Conformément à la réglementation, voici les contrôles que je réalise lors de l'entretien annuel de votre chaudière gaz à Valence et dans l'agglomération valentinoise.
              </p>
              <div className="space-y-3 sm:space-y-4">
                {checklist.map((item, index) => (
                  <div key={index} className="flex items-start bg-gradient-to-r from-teal-50 to-white p-3 sm:p-4 rounded-lg border border-teal-100">
                    <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center bg-teal-600 rounded-full mr-2 sm:mr-3 mt-0.5 flex-shrink-0">
                      <i className="ri-check-line text-xs sm:text-sm text-white"></i>
                    </div>
                    <p className="text-xs sm:text-sm text-gray-700 leading-relaxed font-medium">{item}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="relative h-64 sm:h-96 lg:h-full min-h-[400px] sm:min-h-[600px]">
              <img
                src="https://readdy.ai/api/search-image?query=heating%20technician%20checking%20boiler%20maintenance%20checklist%20professional%20inspection%20tools%20equipment%20clipboard%20clean%20simple%20background%20realistic%20detailed%20professional%20photography%20high%20quality%20bright%20lighting%20teal%20orange%20theme&width=600&height=900&seq=checklist-entretien-valence-detail-2025&orientation=portrait"
                alt="Checklist entretien chaudière"
                className="w-full h-full object-cover object-top rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Processus */}
      <section className="py-12 sm:py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Comment se Déroule l'Entretien ?
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
              Un processus simple et transparent en 4 étapes
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 relative">
            {processus.map((etape, index) => (
              <div key={index} className="relative">
                <div className="text-center">
                  <div className="w-20 h-20 sm:w-32 sm:h-32 flex items-center justify-center bg-gradient-to-br from-teal-600 to-orange-600 rounded-full mx-auto mb-4 sm:mb-6 shadow-xl">
                    <span className="text-2xl sm:text-4xl font-bold text-white">{etape.numero}</span>
                  </div>
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">{etape.titre}</h3>
                  <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">{etape.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Marques */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Marques Entretenues
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
              J'assure l'entretien de toutes les grandes marques de chaudières et climatisations
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 sm:gap-6">
            {marques.map((marque, index) => (
              <div key={index} className="bg-gradient-to-br from-gray-50 to-white p-4 sm:p-6 rounded-xl border border-gray-200 text-center hover:shadow-lg transition-shadow">
                <h3 className="text-sm sm:text-base font-bold text-gray-900 mb-1 sm:mb-2">{marque.nom}</h3>
                <div className="flex justify-center gap-0.5 sm:gap-1">
                  {[...Array(marque.note)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-xs sm:text-sm"></i>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contenu SEO */}
      <section className="py-12 sm:py-20 bg-gradient-to-br from-teal-50 via-white to-orange-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-8">
            Entretien Chaudière et Climatisation : Obligations et Avantages à Valence
          </h2>
          
          <div className="space-y-6 text-gray-700 leading-relaxed">
            <p className="text-lg">
              L'entretien régulier de vos équipements de chauffage et de climatisation n'est pas seulement une obligation légale à Valence, c'est aussi un investissement intelligent pour votre confort, votre sécurité et votre portefeuille. En tant que plombier chauffagiste professionnel à Valence, je vous accompagne dans la maintenance préventive de tous vos équipements thermiques.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              L'Entretien Obligatoire de la Chaudière à Valence
            </h3>
            <p>
              Depuis 2009, l'entretien annuel des chaudières gaz est obligatoire en France, y compris à Valence et dans toute l'agglomération valentinoise. Cette obligation concerne toutes les chaudières de 4 à 400 kW, qu'elles soient au gaz naturel, au fioul ou au bois. L'entretien doit être réalisé par un professionnel qualifié qui effectue au minimum 10 points de contrôle réglementaires et vous remet une attestation d'entretien officielle.
            </p>
            <p>
              Cette attestation est essentielle : elle doit être conservée et présentée à votre assurance en cas de sinistre lié à la chaudière. Le non-respect de cette obligation peut entraîner une réduction significative de l'indemnisation en cas de dégât. Au-delà de l'aspect légal, l'entretien annuel de votre chaudière à Valence garantit votre sécurité en détectant les risques d'intoxication au monoxyde de carbone et les fuites de gaz.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              Entretien Climatisation : Réglementation et Fréquence
            </h3>
            <p>
              L'entretien des climatisations est également encadré par la réglementation. Selon le décret n°2020-912, les climatiseurs de puissance supérieure à 4 kW (soit la majorité des installations résidentielles à Valence) doivent être entretenus tous les 2 ans minimum. Pour les systèmes de plus de 70 kW, un contrôle annuel est obligatoire. Cet entretien comprend le nettoyage des filtres, la désinfection des unités, le contrôle de l'étanchéité du circuit frigorifique et la vérification des performances énergétiques.
            </p>
            <p>
              Même si votre climatisation est de puissance inférieure à 4 kW, je recommande vivement un entretien annuel à Valence. Cela permet de maintenir des performances optimales, d'éviter les pannes en pleine canicule, de garantir une bonne qualité d'air intérieur et de prolonger significativement la durée de vie de votre équipement.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              Les Avantages Concrets d'un Entretien Régulier
            </h3>
            <p>
              Au-delà des obligations légales, l'entretien régulier de vos équipements à Valence présente de nombreux avantages concrets. Une chaudière bien entretenue consomme nettement moins d'énergie qu'une chaudière négligée. Sur une facture annuelle de chauffage de 1500€, cela représente une économie de 120 à 180€ par an. L'entretien est donc rapidement rentabilisé.
            </p>
            <p>
              L'entretien préventif prolonge également la durée de vie de vos équipements de 30 à 50%. Une chaudière bien entretenue peut fonctionner 20 à 25 ans, contre 12 à 15 ans sans entretien régulier. Enfin, la maintenance préventive permet de détecter les problèmes avant qu'ils ne deviennent graves et coûteux, évitant ainsi les pannes en plein hiver ou en pleine canicule à Valence.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              Le Contrat d'Entretien Annuel : Sérénité Garantie
            </h3>
            <p>
              Pour une tranquillité d'esprit totale à Valence, je propose des contrats d'entretien annuels qui incluent l'entretien obligatoire de votre chaudière avec attestation, un contrôle préventif de votre installation de chauffage, un dépannage prioritaire en cas de panne (intervention sous 24h), et un tarif préférentiel sur toutes les réparations et pièces détachées. Vous pouvez également étendre le contrat à vos autres équipements (climatisation, chauffe-eau, pompe à chaleur).
            </p>
            <p>
              Avec un contrat d'entretien, vous n'avez plus à penser à programmer l'intervention : je vous contacte automatiquement chaque année pour planifier l'entretien au moment optimal, avant la période de chauffe. C'est la formule idéale pour des économies sur le long terme et une sérénité garantie toute l'année à Valence et dans toute l'agglomération valentinoise.
            </p>
          </div>
        </div>
      </section>

      {/* Témoignages */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Témoignages Clients
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
              Ce que disent mes clients de Valence et alentour sur mes services d'entretien
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-8">
            {temoignages.map((temoignage, index) => (
              <div key={index} className="bg-gradient-to-br from-gray-50 to-white p-5 sm:p-8 rounded-xl border border-gray-200 shadow-lg hover:shadow-xl transition-shadow">
                <div className="flex items-center mb-3 sm:mb-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-gradient-to-br from-teal-600 to-orange-600 rounded-full mr-3 sm:mr-4 flex-shrink-0">
                    <span className="text-base sm:text-lg font-bold text-white">{temoignage.nom.charAt(0)}</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 text-sm sm:text-base">{temoignage.nom}</h3>
                    <p className="text-xs sm:text-sm text-gray-600">{temoignage.ville}</p>
                  </div>
                </div>
                <div className="flex gap-0.5 sm:gap-1 mb-3 sm:mb-4">
                  {[...Array(temoignage.note)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-sm sm:text-base"></i>
                  ))}
                </div>
                <p className="text-xs sm:text-sm text-gray-700 leading-relaxed italic">"{temoignage.texte}"</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Zone Intervention */}
      <section className="py-12 sm:py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Zones d'Intervention pour Entretien
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto mb-6 sm:mb-8">
              J'interviens pour l'entretien de vos équipements dans toute l'agglomération valentinoise
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6 max-w-5xl mx-auto">
            {['Valence', 'Bourg-lès-Valence', 'Guilherand-Granges', 'Portes-lès-Valence', 'Saint-Péray', 'Soyons', 'Étoile-sur-Rhône', 'Montélier'].map((ville, index) => (
              <div key={index} className="flex items-center justify-center bg-white p-3 sm:p-4 rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                <i className="ri-map-pin-line text-teal-600 mr-1.5 sm:mr-2 flex-shrink-0"></i>
                <span className="font-semibold text-gray-800 text-xs sm:text-sm">{ville}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Questions Fréquentes sur l'Entretien
            </h2>
            <p className="text-base sm:text-lg text-gray-600">
              Toutes les réponses à vos questions sur l'entretien de vos équipements à Valence
            </p>
          </div>

          <div className="space-y-4">
            {faq.map((item, index) => (
              <div key={index} className="bg-gradient-to-br from-gray-50 to-white rounded-xl border border-gray-200 overflow-hidden">
                <button
                  onClick={() => setOpenFaqIndex(openFaqIndex === index ? null : index)}
                  className="w-full text-left p-6 flex items-start justify-between hover:bg-gray-50 transition-colors cursor-pointer"
                >
                  <div className="flex items-start flex-1">
                    <i className="ri-question-line text-teal-600 text-xl mr-3 mt-1 flex-shrink-0"></i>
                    <h3 className="text-lg font-bold text-gray-900 pr-4">{item.question}</h3>
                  </div>
                  <i className={`ri-arrow-${openFaqIndex === index ? 'up' : 'down'}-s-line text-2xl text-gray-400 flex-shrink-0`}></i>
                </button>
                {openFaqIndex === index && (
                  <div className="px-6 pb-6">
                    <p className="text-sm text-gray-600 leading-relaxed ml-8">{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section with Background */}
      <section className="relative py-14 sm:py-20">
        <div className="absolute inset-0 z-0">
          <img
            src="https://readdy.ai/api/search-image?query=professional%20heating%20maintenance%20service%20technician%20working%20modern%20boiler%20clean%20organized%20workshop%20background%20realistic%20detailed%20professional%20photography%20high%20quality%20bright%20lighting%20teal%20orange%20theme&width=1920&height=600&seq=entretien-cta-background-valence-2025&orientation=landscape"
            alt="Contactez-nous pour l'entretien"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-teal-900/90 via-teal-800/85 to-orange-900/80"></div>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4 sm:mb-6">
            Planifiez l'Entretien de Vos Équipements
          </h2>
          <p className="text-base sm:text-lg text-teal-50 mb-6 sm:mb-8 leading-relaxed">
            Contactez-moi pour programmer l'entretien obligatoire de votre chaudière ou climatisation à Valence. Devis gratuit et attestation officielle remise.
          </p>
          <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4 justify-center">
            <a
              href="tel:+33760705475"
              className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 bg-white text-teal-600 font-semibold rounded-lg hover:bg-gray-100 transition-colors shadow-xl whitespace-nowrap cursor-pointer text-sm sm:text-base"
            >
              <i className="ri-phone-line mr-2"></i>
              Appelez le 07 60 70 54 75
            </a>
            <a
              href="mailto:ioncertanpro@gmail.com"
              className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 bg-teal-600/90 backdrop-blur-sm border-2 border-white text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors shadow-xl whitespace-nowrap cursor-pointer text-sm sm:text-base"
            >
              <i className="ri-mail-line mr-2"></i>
              Demander un contrat d'entretien
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}